import "./App.css";
import useDevice from "./hooks/useDevice";
import useOrientation from "./hooks/useOrientation";
import DynamicHead from "./DynamicHead";

import { RadioProvider } from "./services/RadioProvider";
import { AudioProvider } from "./services/AudioContext";
import { AuthProvider } from "./services/AuthContext";
import { AlertProvider } from "./services/AlertProvider";

import RadioPlayerMain from "./components/Player/RadioPlayerMain";
import RadioHistoryMain from "./components/Player/RadioHistoryMain"
import Logo from "./components/Logo/Logo";
import RadioPlayerCoverFrame from "./components/RadioPlayerCoverFrame/RadioPlayerCoverFrame";
import BubbleCanvas from "./components/Canvas/BubbleCanvas";
import GuideMain from "./components/Guide/GuideMain";
import UserModal from "./components/UsaerModal/UserModal"
import Ad from "./components/Ad/Ad"

import MBubbleCanvas from "./mComponents/MCanvas/MBubbleCanvas";
import MRadioPlayerMain from "./mComponents/MPlayer/MRadioPlayerMain";
import MLogo from "./mComponents/Mlogo/MLogo";
import MRadioPlayerCoverFrame from "./mComponents/MRadioPlayerCoverFrame/MRadioPlayerCoverFrame";
import MGuideMain from "./mComponents/MGuide/MGuideMain";
import MUserModal from "./mComponents/MUserModal/MUserModel";

import LBubbleCanvas from "./lComponents/LCanvas/LBubbleCanvas";
import LRadioPlayerMain from "./lComponents/LPlayer/LRadioPlayerMain";
import LGuideMain from "./lComponents/LGuide/LGuideMain";
import LLogo from "./lComponents/LLogo/LLogo";
import LRadioPlayerCoverFrame from "./lComponents/LRadioPlayerCoverFrame/LRadioPlayerCoverFrame";
import LUserModal from "./lComponents/LUserModal/LUserModal";

function InnerApp() {
  const isMobile = useDevice();
  const orientation = useOrientation();

  return (
    <>
      <DynamicHead />

      {isMobile
        ? (orientation === "portrait"
          ? <>
            <MBubbleCanvas />
            <MLogo />
            <MRadioPlayerCoverFrame />
            <MRadioPlayerMain />
            <MGuideMain />
            <MUserModal />
          </>
          : <>
            <LBubbleCanvas />
            <LLogo />
            <LRadioPlayerCoverFrame />
            <LRadioPlayerMain />
            <LGuideMain />
            <LUserModal />
          </>)
        : <>
          <BubbleCanvas />
          <Ad />
          <Logo />
          <RadioPlayerMain />
          <RadioHistoryMain />
          <RadioPlayerCoverFrame />
          <GuideMain />
          <UserModal />
        </>
      }
    </>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <RadioProvider>
        <AudioProvider>
          <AlertProvider>
            <InnerApp />
          </AlertProvider>
        </AudioProvider>
      </RadioProvider>
    </AuthProvider>
  );
}